import http from "../shared/axios";
import { Corp_Lead_Create, Corp_Lead_Dedupe, Corp_Lead_Update, Lead_Retrieve, Corp_OTP_Validation, Get_Dump_Data } from "../shared/ServiceCommonEndpoints";
import { funcGenerateUniqueKey, getApiSubPayload, getGEMID1, getGEMID2, getLastCs, getShortCode } from "../shared/utility";
import EncrDecrServiceService from "./EncrDecrService.Service";

export default class DumpDataService {
  static funcFetchDumpData(empData, action) {
 //   delete empData.isSprintDumpTrackRetrieve;
    const empInfo = {
      data: {
        ...empData,
      },
      action: action,
      type: "SwiftAppCorp",
    };
    return http.post(Get_Dump_Data, empInfo, {
      headers: {
        "IDENTIFIER_1": localStorage.getItem("visitorID"),
        "DeviceInfo": localStorage.getItem("deviceinfo"),
        "ENCRYPTED_ID": "1"
      }
    });
  }

  static funcValidateDumpOtp(dumpData , otpInput, corpCard ,action) {
    const otpInputInfo = {
      data: {
        firstName: dumpData.firstName,
       isDumpBased: "Y",
        reasonCode: "101",
        otp: otpInput,
        dsignString: funcGenerateUniqueKey()

      },
      action: action,
      type: corpCard ? "SwiftAppCorp" : "Swift App",
    };
    if(dumpData.mobileNo){
      otpInputInfo.data.mobileNumber = dumpData.mobileNo;
    }else if(dumpData.officialEmail){
      otpInputInfo.data.emailId = dumpData.officialEmail;
      otpInputInfo.data.cardNumber = dumpData.cardNumber;
    }
    const url = corpCard ? Corp_OTP_Validation : Lead_Retrieve
    return http.post(url, otpInputInfo, {
      headers: {
        "IDENTIFIER_1": localStorage.getItem("visitorID"),
        "DeviceInfo": localStorage.getItem("deviceinfo"),
        "ENCRYPTED_ID": "1"
      }
    });
  }

  static funcCreateCorpSsl(personalInfo, cardType, dumpData) {
    const middleNameval = personalInfo.middleName ? personalInfo.middleName.trim() : "";
    let personalDetails = {
      channelCode: personalInfo.channelCode,
      cardType: cardType,
      firstName: personalInfo.firstName,
      middleName: middleNameval,
      lastName: personalInfo.lastName,
      consentFlag: "Y",
      employeeId : dumpData.employeeNumber,
      employeeGrade : dumpData.employeeGrade,
      dumpExpiryDate : dumpData.dumpExpiryDate,
      promo:dumpData.promo,
      mobileNumber: personalInfo.mobileNo,
      reasonCode: "101",
      dsignString: funcGenerateUniqueKey(),
      isDumpBased : dumpData.employeeNumber ? 'Y' : 'N',
      sourceCode : dumpData?.sourceCode,
      feeCode : dumpData?.feeCode
    };
    let subPayload = getApiSubPayload();
    delete subPayload.shortCode;
    personalDetails = { ...personalDetails, ...subPayload };
    const sslData = {
      data: {
        ...personalDetails
      },
      action: "submitWithoutAuth",
      type: "SwiftAppCorp",
    };

    var encyMobile = EncrDecrServiceService.set(personalInfo.mobileNo)

    return http.post(Corp_Lead_Create, sslData,
      {
        headers: {
          "IDENTIFIER_1": encyMobile,
          "IDENTIFIER_2": localStorage.getItem("visitorID"),
          "ENCRYPTED_ID": "1"
        }
      }
    );
  }

  static corpValidatePan({ firstName, middleName, lastName, panNumber, dob, shortCode, nameOnCard, nameDeviation, dobDeviation }) {
    let requestPayload = {
      dateOfBirth: dob,
      dobDeviation: dobDeviation,
      firstName: firstName,
      middleName: middleName,
      lastName: lastName,
      nameDeviation: nameDeviation,
      nameOnCard: nameOnCard,
      panNumber: panNumber,
      shortCode: shortCode
    };
    const payload = {
      data: requestPayload,
      action: "submit",
      type: "SwiftAppCorp"
    }
    return http.post(Corp_Lead_Dedupe, payload,
      {
        headers: {
          "IDENTIFIER_1": shortCode,
          "IDENTIFIER_2": localStorage.getItem("visitorID")
        }
      }
    );
  }

  static funcUpdateCorpSSLByShortCodev1(userDetail, action) {
    let userInfo = { ...userDetail };
    if (action === "updateProfSubmit") {
      let gemId1 = getGEMID1();
      let gemId2 = getGEMID2();
      let lastCs = getLastCs();
      // let shortCode = userDetail.shortCode ? userDetail.shortCode : getShortCode();
      if (gemId1 && gemId1 !== "null" && gemId1 !== "" && gemId1 !== "undefined")
        userInfo.gemId1 = gemId1;
      if (gemId2 && gemId2 !== "null" && gemId2 !== "" && gemId2 !== "undefined")
        userInfo.gemId2 = gemId2;
      if (lastCs && lastCs !== "null" && lastCs !== "")
        userInfo.lastCs = lastCs;
      // if(shortCode && shortCode !== "null" && shortCode !== "")
      // userInfo.shortCode = shortCode;
    }
    //else if(action === "ChangeNetwork"){
    let shortCode = userDetail.shortCode ? userDetail.shortCode : getShortCode();
    if (shortCode && shortCode !== "null" && shortCode !== "")
      userInfo.shortCode = shortCode;
    //}
    
    
    const sslUpdateData = {
      data: {
        ...userInfo,
      },
      action: action,
      type: "SwiftAppCorp",
    };
    let mothersNameSign = localStorage.getItem("dSignVPlusMotherName");
    let emailSign = localStorage.getItem("dSignVPlusEmailId");
    return http.post(Corp_Lead_Update, sslUpdateData, {
      headers: {
        "IDENTIFIER_1": userDetail.shortCode,
        "IDENTIFIER_2": localStorage.getItem("visitorID"),
        "DeviceInfo": localStorage.getItem("deviceinfo"),
        "dSignVPlusMotherName": mothersNameSign ? mothersNameSign : null,
        "dSignVPlusEmailId": emailSign ? emailSign : null
      }
    });
  }
}